import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import Layout from "../components/layout"
import ImageAndTextSection from "../components/Marketing/ImageAndTextSection"
import PortableText from "../components/portableText"
import SEO from "../components/seo"

export const query = graphql`
  query WrittenInterviewQuery($id: String!) {
    writtenInterview: sanityWrittenInterview(id: { eq: $id }) {
      id
      title
      image {
        asset {
          fluid {
            ...GatsbySanityImageFluid
          }
        }
      }
      _rawIntro
      _rawInterviewText(resolveReferences: { maxDepth: 2 })
      images {
        asset {
          fluid {
            ...GatsbySanityImageFluid
          }
        }
      }
    }
  }
`

const WrittenInterview = props => {
  const {
    title,
    image,
    _rawIntro,
    _rawInterviewText,
    images,
  } = props.data.writtenInterview

  return (
    <Layout fixedNavbar={false}>
      <SEO title="Written Interview" />
      <div className="mb-3">
        <ImageAndTextSection image={image} text={title} headingSize="h1" />
      </div>
      <Container>
        <Row>
          <Col sm={{ span: 8, offset: 2 }}>
            <PortableText blocks={_rawIntro} />
            <Row>
              <Col>
                <img
                  src={images[0].asset.fluid.src}
                  className="img-fluid"
                  style={{ height: 350 }}
                />
              </Col>
              <Col>
                <img
                  src={images[1].asset.fluid.src}
                  className="img-fluid"
                  style={{ height: 350 }}
                />
              </Col>
            </Row>
            <hr />
            {_rawInterviewText.map(segment => (
              <section className="mb-3">
                <b>{segment.speaker.name || segment.speaker.englishName}:</b>{" "}
                {segment.speech}
              </section>
            ))}
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default WrittenInterview
